import { HorizontalBar, mixins } from "vue-chartjs"
import { forOwn } from "lodash"
import numeral from "numeral"

export default HorizontalBar.extend({
    mixins: [mixins.reactiveProp],
    props: {
        chartData: {
            type: Array | Object,
            required: false
        },
        legend: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        legend: {
            handler (newOption, oldOption) {
                this.options.legend.display = this.legend
                this._chart.destroy()
                this.renderChart(this.chartData, this.options)
            },
            deep: true
        }
    },
    methods: {
        click (event) {
            try {
                const chart_element = this._chart.getElementAtEvent(event)[0]
                const dataset = this._chart.config.data.datasets[chart_element._datasetIndex]
                this.$emit("click", dataset.project.id, event)
            } catch (e) {}
        }
    },
    data () {
        return {
            options: {
                onClick: this.click,
                tooltips: {
                    callbacks: {
                        title: (tooltipItems, data) => {
                            return data.datasets[tooltipItems[0].datasetIndex].label
                        },
                        label: function (tooltipItem, data) {
                            const amount_numeral = numeral(tooltipItem.xLabel)
                            const amount = amount_numeral.value()
                            if(amount <= 0) return false
                            let total = 0
                            forOwn(data.datasets, dataset => {
                                total += dataset.data[tooltipItem.index]
                            })
                            return amount_numeral.format("0,0.0") + "h / " + numeral(total).format("0,0.0") + "h (" + numeral((amount / total) * 100).format("0,0.0") + "%)"
                        }
                    },
                    mode: "point"
                },
                scales: {
                    yAxes: [{
                        stacked: true,
                        gridLines: {
                            display: false,
                            drawBorder: false,
                            color: "rgba(0, 39, 79, 0.1)"
                        }
                    }],
                    xAxes: [{
                        stacked: true,
                        ticks: {
                            beginAtZero: true,
                            callback: function (value, index, values) {
                                return numeral(value).format("0,0") + "h"
                            }
                        },
                        gridLines: {
                            display: false,
                            color: "rgba(0, 39, 79, 0.1)"
                        },
                        categoryPercentage: 0.9,
                        barPercentage: 0.8
                    }]
                },
                legend: {
                    display: this.legend,
                    position: "bottom",
                    labels: {
                        fontSize: 11,
                        // fontFamily: "'Helvetica Neue', Helvetica, Arial, 'sans-serif'",
                        fontStyle: "bold",
                        fontColor: "#00274F",
                        boxWidth: 10,
                        padding: 13
                    }
                },
                responsive: true,
                maintainAspectRatio: false
            }
        }
    },
    mounted () {
        this.renderChart(this.chartData, this.options)
    }
})
